/**
 * Powers three conversion blocks, all built on the same native
 * Cart AJAX API (window.ElongeCart.addItems from assets/cart.js):
 *   1. Quantity offer  — sets the real quantity on the main product form.
 *   2. Bundle builder  — sums real selected-variant prices, adds them all.
 *   3. Frequently bought together — same pattern as bundle builder.
 */
(function () {
  'use strict';

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function addToCart(items) {
    if (window.ElongeCart && window.ElongeCart.addItems) return window.ElongeCart.addItems(items);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  /* ---------------- Quantity offer ---------------- */
  document.querySelectorAll('[data-quantity-offer]').forEach(function (section) {
    var options = section.querySelectorAll('[data-quantity-offer-option]');
    options.forEach(function (option) {
      option.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); o.querySelector('[data-quantity-offer-radio]').checked = false; });
        option.classList.add('is-selected');
        option.querySelector('[data-quantity-offer-radio]').checked = true;

        var quantity = parseInt(option.getAttribute('data-quantity'), 10) || 1;
        var mainQuantityInput = document.querySelector('[data-product-form-variant-id]')
          ? document.querySelector('#ProductForm [data-quantity-input]')
          : document.querySelector('[data-quantity-input]');
        if (mainQuantityInput) {
          mainQuantityInput.value = quantity;
          mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });

  /* ---------------- Bundle builder ---------------- */
  document.querySelectorAll('[data-bundle-builder]').forEach(function (section) {
    var selects = section.querySelectorAll('[data-bundle-slot-select]');
    var totalEl = section.querySelector('[data-bundle-total]');
    var saveEl = section.querySelector('[data-bundle-save]');
    var progressEl = section.querySelector('[data-bundle-progress]');
    var addBtn = section.querySelector('[data-bundle-add-to-cart]');
    var discountPercent = addBtn ? parseFloat(addBtn.getAttribute('data-discount-percent')) || 0 : 0;

    function refresh() {
      var selected = Array.prototype.filter.call(selects, function (s) { return s.value; });
      var total = selected.reduce(function (sum, s) { return sum + parseInt(s.options[s.selectedIndex].getAttribute('data-price'), 10); }, 0);
      if (totalEl) totalEl.textContent = money(total);
      if (saveEl) saveEl.textContent = money(total * discountPercent / 100);
      if (progressEl) progressEl.textContent = selected.length + ' / ' + selects.length + ' sélectionnés';
      if (addBtn) addBtn.disabled = selected.length !== selects.length;

      selects.forEach(function (s) {
        var slot = s.closest('[data-bundle-slot]');
        var img = slot.querySelector('[data-bundle-slot-image]');
        if (s.value && img) {
          img.src = s.options[s.selectedIndex].getAttribute('data-image');
          img.hidden = false;
          slot.classList.add('is-filled');
        } else if (img) {
          img.hidden = true;
          slot.classList.remove('is-filled');
        }
      });
    }
    selects.forEach(function (s) { s.addEventListener('change', refresh); });
    refresh();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = Array.prototype.filter.call(selects, function (s) { return s.value; })
          .map(function (s) { return { id: s.value, quantity: 1 }; });
        if (!items.length) return;
        addToCart(items);
      });
    }
  });

  /* ---------------- Frequently bought together ---------------- */
  document.querySelectorAll('[data-fbt]').forEach(function (section) {
    var checkboxes = section.querySelectorAll('[data-fbt-checkbox]');
    var totalEl = section.querySelector('[data-fbt-total]');
    var addBtn = section.querySelector('[data-fbt-add-to-cart]');
    var mainPrice = addBtn ? parseInt(document.querySelector('[data-product-json-source]')
      ? JSON.parse(document.querySelector('[data-product-json-source]').textContent).price
      : 0, 10) : 0;

    function refresh() {
      var total = mainPrice;
      checkboxes.forEach(function (cb) {
        if (cb.checked) total += parseInt(cb.closest('[data-fbt-item]').getAttribute('data-price'), 10);
      });
      if (totalEl) totalEl.textContent = money(total);
    }
    checkboxes.forEach(function (cb) { cb.addEventListener('change', refresh); });
    refresh();

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var items = [{ id: addBtn.getAttribute('data-main-variant-id'), quantity: 1 }];
        checkboxes.forEach(function (cb) {
          if (cb.checked) items.push({ id: cb.closest('[data-fbt-item]').getAttribute('data-variant-id'), quantity: 1 });
        });
        addToCart(items);
      });
    }
  });
})();
